import { Button, Dialog, List, ListItem, ListItemButton, Typography, TextareaAutosize } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';

import React, { useState } from 'react';

// Styled component for the dialog content
const DialogContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '16px',
});

const CoachingDialog = (props) => {
  const [checked, setChecked] = useState([]);
  const [comment, setComment] = useState('');

  const handleClickValidate = () => {
    if (props.coachings.length > 0 && checked.length === 0) {
      window.alert("Aucun type de support n'a été sélectionné, veuillez en sélectioner au moins un !");
    } else if (props.coachings.length === 0 && comment.length === 0) {
      window.alert("Veuillez spécifier un commentaire !");
    } else {
      props.handleClickValidateCoachings(checked, comment);
      setChecked([]);
      setComment('');
    }
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  return (
    <Dialog open={props.open} maxWidth="xs" margin="auto">
      <DialogContent>
        <Typography variant="h5" align="center" gutterBottom>
          Please select the type(s) of support
        </Typography>
        <List>
          {props.coachings.map((coaching) => (
            <ListItem key={coaching.coachingId}>
              <ListItemButton onClick={handleToggle(coaching)}>
                <Checkbox
                  edge="start"
                  checked={checked.indexOf(coaching) !== -1}
                  tabIndex={-1}
                  disableRipple
                />
                <Typography variant="body1">{coaching.name}</Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Typography variant="h6" align="center" gutterBottom>
          Comments :
        </Typography>
        <TextareaAutosize
          rows={4}
          placeholder="Ajouter des commentaires..."
          value={comment}
          onChange={handleCommentChange}
          style={{ width: '100%', marginBottom: '16px', padding: '8px' }}
        />
        <Button onClick={handleClickValidate} variant="contained" color="primary">
          Validate
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CoachingDialog;
